module.exports = "https://s91588.cdn.ngenix.net/news-frontend/_next/static/images/tests-d88b87794f02f89ee7daf650f47c0133.jpg";